// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { monthsToYears as fn } from "../monthsToYears.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const monthsToYears = convertToFP(fn, 1);

// Fallback for modularized imports:
export default monthsToYears;
